// extracted by mini-css-extract-plugin
module.exports = {"iconSize":"AreaInfoPanel-styles_iconSize___eVMJ","openAll":"AreaInfoPanel-styles_openAll__5ElDb","spanClick":"AreaInfoPanel-styles_spanClick__260JR"};